import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Models } from '@ibexfusion/models';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { AssetSelectorComponent } from '../../../../components/asset-selector/asset-selector.component';
import { EnvironmentService } from '@services/environment/environment.service';
import { MessengerService } from '@services/messenger/messenger.service';

@Component({
  selector: 'app-package-installed-widget-editor',
  templateUrl: './package-installed-widget-editor.component.html',
  styleUrls: ['./package-installed-widget-editor.component.scss'],
  standalone: false
})
export class PackageInstalledWidgetEditorComponent implements OnInit {

  @Input() widget: Models.PackageInstalledWidget;
  @Input() pak: Models.Package;
  @Input() availableLanguages: any[];
  @Output() widgetSave: EventEmitter<Models.PackageInstalledWidget> = new EventEmitter();
  @Output() widgetChange = new EventEmitter();

  public imageAssetPath: any;
  public superadmin = false;

  public selectedIndex = 0;

  public editorOptions = {
    toolbar: [[{ 'header': [2, false] }], ['bold']],
    formats: ['header', 'bold'],
    embedded: ['break']
  };

  public codeEditorOptions = { maxLines: 30, minLines: 20, fontSize: '16px', autoScrollEditorIntoView: true };

  constructor(private dialog: MatDialog, private environmentService: EnvironmentService, private ms: MessengerService) {
    this.imageAssetPath = this.environmentService.getImageAssetPath();
  }

  ngOnInit() {
    const privileges = this.ms.$superadminPrivileges.getValue();

    if (!!privileges) {
      this.superadmin = !!privileges.find(p => p.privilegeName === 'superadmin' && p.value === 'packages');
    }
    for (let i = 0; i < this.availableLanguages.length; i++) {
      if (!this.widget.translations.find(t => t.language === this.availableLanguages[i])) {
        const newTranslation = new Models.PackageInstalledWidgetTranslation();
        newTranslation.populateFromJSON({ hidden: false, language: this.availableLanguages[i] });
        this.widget.translations.splice(i, 0, newTranslation);
      }
    }
    if (!!this.pak?.ibexTablet?.enabled) {
      this.widget.tabletWidgetConfig = this.widget.tabletWidgetConfig || new Models.PackageInstalledWidgetTablet();
      this.widget.tabletWidgetConfig.translations = this.widget.tabletWidgetConfig.translations || [];
      this.widget.tabletWidgetConfig.imagePath = this.widget.tabletWidgetConfig.imagePath || undefined;
      for (let i = 0; i < this.availableLanguages.length; i++) {
        if (!this.widget.tabletWidgetConfig.translations.find(t => t.language === this.availableLanguages[i])) {
          const newTranslation = new Models.PackageInstalledWidgetTranslation();
          newTranslation.populateFromJSON({ hidden: false, language: this.availableLanguages[i] });
          this.widget.tabletWidgetConfig.translations.splice(i, 0, newTranslation);
        }
      }
    }
    if (!this.widget?.seasonalImages?.[0]?.imagePath) {
      this.setSeasonalImages(this.widget)
    }
    if (this.widget.tabletWidgetConfig && !this.widget.tabletWidgetConfig.seasonalImages) {
      this.setSeasonalImages(this.widget.tabletWidgetConfig);
    }
  }

  setSeasonalImages(element) {
    if (element.seasonalImages) {
      const imagePaths = element.seasonalImages.map(el => el.imagePath).filter(el => !!el);
      if (imagePaths.length) {
        element.seasonalImages = element.seasonalImages.filter(el => !!el.imagePath);
        return;
      }
    }
    if (!element.imagePath) {
      element.seasonalImages = [];
      return;
    }

    element.seasonalImages = [this.createNewSeasonalImage(element.imagePath)];
  }

  createNewSeasonalImage(imagePath) {
    const seasonalImage = new Models.PackageInstalledWidgetSeasonalImage();
    seasonalImage.populateFromJSON({ imagePath: imagePath, from: new Date(new Date().getFullYear(), 0, 1), to: new Date(new Date().getFullYear(), 11, 31) });
    return seasonalImage;
  }

  async addSeasonalImage(tablet = false) {
    let dialogRef: MatDialogRef<AssetSelectorComponent>;

    dialogRef = this.dialog.open(AssetSelectorComponent, (<any>{ width: '75%', height: '75%', data: { type: 'image' } }));
    const asset: Models.ImageAsset = await dialogRef.afterClosed().toPromise();
    if (!asset) {
      return;
    }
    (!!tablet ? this.widget.tabletWidgetConfig : this.widget).seasonalImages.push(this.createNewSeasonalImage(asset.path));
  }

  removeSeasonalImage(index, tablet = false) {
    (!!tablet ? this.widget.tabletWidgetConfig : this.widget).seasonalImages.splice(index, 1);
  }

  quillChanged(event, lang) {
    for (let i = 0; i < this.widget.translations.length; i++) {
      if (this.widget.translations[i].language === lang) {
        this.widget.translations[i].content = event;
      }
    }
  }

  changeType(event: any, type = 'default') {
    (type === 'tablet' ? this.widget.tabletWidgetConfig : this.widget)?.translations?.forEach(el => {
      el.widgetStyle = event;
    });
  }

  resetWidgetStyle(type = 'default') {
    (type === 'tablet' ? this.widget.tabletWidgetConfig : this.widget)?.translations?.forEach(el => {
      el.widgetStyle = null;
    });
  }

  saveWidget() {
    this.widgetSave.emit(this.widget);
  }

  tabChange(event) {
    this.selectedIndex = event.index
  }
}
